import { omit } from 'lodash';
import { HashUtil } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../../shared/url_helpers';

const PAID_PRICE_MIN = '0.01';
const FREE_PRICE = '0';

class IndexParams {
  constructor({ push, location, params }) {
    this.push = push;
    this.query = location.query;
    this.pathname = location.pathname;
    this.params = params;
  }

  get showAllPaid() {
    return this.priceMin === PAID_PRICE_MIN;
  }

  get free() {
    return this.priceMax === FREE_PRICE;
  }

  get categorySlug() {
    return this.params.categorySlug;
  }

  get brand() {
    return this.query.brand;
  }

  get fileTypes() {
    return this.query.file_type;
  }

  get operatingSystem() {
    return this.query.operating_system;
  }

  get priceMin() {
    return this.query.price_min;
  }

  get priceMax() {
    return this.query.price_max;
  }

  changeCategory(slug) {
    const path = UrlHelpers.softwarePath(slug);
    const params = omit(this.query, 'page');
    this.push({ pathname: path, query: params });
  }

  changePage(page) {
    const newQuery = {};
    Object.assign(newQuery, this.query);
    Object.assign(newQuery, { page });
    this.push({ pathname: this.pathname, query: newQuery });
  }

  changeBrands(brands) {
    this.updateQuery({ brand: brands });
  }

  changeFileTypes(slugs) {
    this.updateQuery({ file_type: slugs });
  }

  changeOperatingSystem(osSlug) {
    this.updateQuery({ operating_system: osSlug });
  }

  changePriceFilter(prices) {
    const newPrices = {};
    if ('priceMin' in prices) {
      newPrices.price_min = prices.priceMin;
    }
    if ('priceMax' in prices) {
      newPrices.price_max = prices.priceMax;
    }
    this.updateQuery(newPrices);
  }

  togglePaid() {
    if (this.showAllPaid) {
      this.changePriceFilter({ priceMin: null });
    } else {
      this.changePriceFilter({ priceMin: PAID_PRICE_MIN, priceMax: null });
    }
  }

  toggleFree() {
    if (this.free) {
      this.changePriceFilter({ priceMin: null, priceMax: null });
    } else {
      this.changePriceFilter({ priceMin: FREE_PRICE, priceMax: FREE_PRICE });
    }
  }

  changeSort(e) {
    const sort = e.target.value;
    this.updateQuery({ sort });
  }

  updateQuery(filters) {
    // reset to page one
    const params = omit(this.query, 'page');
    let newParams = Object.assign(params, filters);
    newParams = HashUtil.rejectBlankValues(newParams);
    this.push({ pathname: this.pathname, query: newParams });
  }
}

export default IndexParams;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/index_params.js